module.exports = __webpack_public_path__ + "static/129029df376a66820b9029349b1330bd70d9556957869419c2525d80e4241417-b6de720e408285111fd0d561d0d0fdc9.png";